/* eslint-disable react/prop-types */
import { useEffect, useState } from "react";
import ArgonTypography from "components/ArgonTypography";
import api from "utils/api";

const formatDateTime = (value) => {
  if (!value) return "N/A";
  const date = new Date(value);
  return date.toLocaleString("en-IN", {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "2-digit",
    minute: "2-digit",
  });
};

const columns = [
  { name: "sno", align: "center" },
  { name: "phone", align: "center" },
  { name: "type", align: "center" },
  { name: "otp", align: "center" },
  { name: "expiresAt", align: "center" },
  { name: "createdAt", align: "center" },
];

const useOtpLogsTableData = (page, limit, phone, type, refresh) => {
  const [logs, setLogs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [totalItems, setTotalItems] = useState(0);
  const [totalPages, setTotalPages] = useState(0);

  const fetchLogs = async () => {
    try {
      setLoading(true);
      const params = {
        page,
        limit,
      };

      if (phone) params.phone = phone;
      if (type) params.type = type;

      const response = await api.get("/auth/otp-logs", { params });
      if (response.data?.success) {
        const payload = response.data.data || {};
        setLogs(payload.logs || []);
        setTotalItems(payload.pagination?.total || 0);
        setTotalPages(payload.pagination?.totalPages || 0);
      } else {
        setLogs([]);
        setTotalItems(0);
        setTotalPages(0);
      }
    } catch (error) {
      console.error("Error fetching OTP logs:", error);
      setLogs([]);
      setTotalItems(0);
      setTotalPages(0);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogs();
  }, [page, limit, phone, type, refresh]);

  const rows = logs.map((log, index) => ({
    sno: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {(page - 1) * limit + index + 1}
      </ArgonTypography>
    ),
    phone: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {log.phone || "N/A"}
      </ArgonTypography>
    ),
    type: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {log.type || "N/A"}
      </ArgonTypography>
    ),
    otp: (
      <ArgonTypography variant="caption" fontWeight="medium" color="text">
        {log.otp || "N/A"}
      </ArgonTypography>
    ),
    expiresAt: (
      <ArgonTypography variant="caption" color="text">
        {formatDateTime(log.expiresAt)}
      </ArgonTypography>
    ),
    createdAt: (
      <ArgonTypography variant="caption" color="text">
        {formatDateTime(log.createdAt)}
      </ArgonTypography>
    ),
  }));

  return {
    columns,
    rows,
    loading,
    totalItems,
    totalPages,
    refetch: fetchLogs,
  };
};

export default useOtpLogsTableData;
